import { getLocalizedDateFormat } from 'utils/getLocalizedDateFormat';
import i18next from 'i18next';
import {
  ISO8601Type,
  ISO8601TupleType,
  isISO8601Type,
  isISO8601Tuple,
  ShiftDateTimeRangeType,
  ShiftDateTimeType,
} from 'types/common.types';
import { DateTime } from 'luxon';

export function parseVerboseDate(
  arg: ISO8601TupleType,
  timeZone?: Nullable<string>,
  is24hTimeFormat?: boolean,
): ShiftDateTimeRangeType;
export function parseVerboseDate(
  arg: ISO8601Type,
  timeZone?: Nullable<string>,
  is24hTimeFormat?: boolean,
): ShiftDateTimeType;
export function parseVerboseDate(
  arg: ISO8601TupleType | ISO8601Type,
  timeZone?: Nullable<string>,
  is24hTimeFormat?: boolean,
): ShiftDateTimeRangeType | ShiftDateTimeType | string {
  const dateTimeZone = timeZone || undefined;
  const date = isISO8601Tuple(arg) ? arg[0] : arg;

  const { dayOfWeek, month } = getLocalizedDateFormat(date, dateTimeZone);
  const timeFormat = is24hTimeFormat ? 'HH:mm' : 'hh:mm a';

  if (isISO8601Tuple(arg)) {
    const startTime = DateTime.fromISO(date).setZone(dateTimeZone).toFormat(timeFormat);
    const endTime = DateTime.fromISO(arg[1]).setZone(dateTimeZone).toFormat(timeFormat);
    return `${dayOfWeek}, ${month}, ${DateTime.fromISO(date)
      .setZone(dateTimeZone)
      .toFormat('d')} ${i18next.t('common:AT')} ${
      is24hTimeFormat ? startTime : startTime.toLowerCase()
    } - ${is24hTimeFormat ? endTime : endTime.toLowerCase()}` as ShiftDateTimeRangeType;
  } else if (isISO8601Type(arg)) {
    const time = DateTime.fromISO(arg).setZone(dateTimeZone).toFormat(timeFormat);
    return `${month}, ${DateTime.fromISO(arg).setZone(dateTimeZone).toFormat('d, yyyy')} at ${
      is24hTimeFormat ? time : time.toLowerCase()
    }` as ShiftDateTimeType;
  } else {
    return '';
  }
}
